(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sv-upsell]');
    if (!root) return;

    var poolEl = document.querySelector('[data-sv-upsell-pool]');
    var POOL = [];
    try { POOL = JSON.parse(poolEl.textContent) || []; } catch (e) { POOL = []; }

    var ADD_URL = root.getAttribute('data-add-url') || '/cart/add';
    var MONEY_FORMAT = root.getAttribute('data-money-format') || '';
    var HOW_MANY = parseInt(root.getAttribute('data-count'), 10);
    if (isNaN(HOW_MANY) || HOW_MANY < 1) HOW_MANY = 3;

    var sheet = root.querySelector('.sv-up__sheet');
    var addedBox = root.querySelector('[data-sv-up-added]');
    var list = root.querySelector('[data-sv-up-list]');
    var sub = root.querySelector('[data-sv-up-sub]');
    var lastFocus = null;

    // Le tiroir panier ne s'ouvre plus tout seul : cette fenetre le remplace.
    // Le reglage « ouverture automatique du panier » reste actif dans le theme :
    // si ce script ne se charge pas, le tiroir panier prend le relais comme avant.
    function stripAutoOpen() {
      var drawers = document.querySelectorAll('cart-drawer-component[auto-open]');
      for (var i = 0; i < drawers.length; i++) drawers[i].removeAttribute('auto-open');
    }

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // Meme rendu des prix que le reste de la boutique (format defini dans Shopify).
    function withDelimiters(cents, precision, thousands, decimal) {
      if (isNaN(cents) || cents == null) return '0';
      var num = (cents / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    function money(cents) {
      var slot = /\{\{\s*(\w+)\s*\}\}/;
      var found = MONEY_FORMAT.match(slot);
      if (!found) return withDelimiters(cents, 2, ',', '.');
      var value;
      switch (found[1]) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        default: value = withDelimiters(cents, 2, ',', '.');
      }
      return MONEY_FORMAT.replace(slot, value);
    }

    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (sheet) {
        sheet.scrollTop = 0;
        sheet.focus({ preventScroll: true });
      }
    }

    function close() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      lastFocus = null;
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sv-up-close]')) { e.preventDefault(); close(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    function renderAdded(item) {
      if (!item) { addedBox.innerHTML = ''; return; }
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      addedBox.innerHTML =
        (img ? '<img src="' + esc(img) + '" alt="" loading="eager">' : '') +
        '<div><p class="sv-up__added-name">' + esc(item.product_title || item.title) + '</p>' +
        '<p class="sv-up__added-price">' + money(item.final_price != null ? item.final_price : item.price) + '</p></div>';
    }

    function renderSuggestions(inCartIds) {
      var picked = POOL.filter(function (p) { return inCartIds.indexOf(p.vid) === -1; }).slice(0, HOW_MANY);
      if (sub) sub.hidden = picked.length === 0;

      list.innerHTML = picked.map(function (p) {
        var img = p.img || '';
        return '<li class="sv-up__card">' +
          '<a class="sv-up__media" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="eager">' : '') +
          '</a>' +
          '<button type="button" class="sv-up__plus" data-vid="' + esc(p.vid) + '" aria-label="Ajouter ' + esc(p.title) + ' au panier">+</button>' +
          '<div class="sv-up__info">' +
          '<p class="sv-up__name">' + esc(p.title) + '</p>' +
          '<p class="sv-up__price">' + esc(p.price) + (p.compare ? '<s>' + esc(p.compare) + '</s>' : '') + '</p>' +
          '</div></li>';
      }).join('');
    }

    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg>';

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.sv-up__plus');
      if (!btn || btn.disabled) return;

      var vid = btn.getAttribute('data-vid');
      btn.disabled = true;

      fetch(ADD_URL + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () {
          btn.innerHTML = CHECK;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Met a jour la pastille du panier dans l'en-tete.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'sv-upsell', data: { source: 'sv-upsell', itemCount: cart.item_count } }
          }));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = '+';
        });
    });

    function show(variantId) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var item = null;
          if (variantId) {
            for (var i = 0; i < items.length; i++) {
              if (String(items[i].variant_id) === String(variantId)) { item = items[i]; break; }
            }
          }
          if (!item) item = items[items.length - 1];

          var ids = items.map(function (it) { return it.variant_id; });
          renderAdded(item);
          renderSuggestions(ids);
          open();
        })
        .catch(function () {});
    }

    // Phase de capture : on passe juste avant le tiroir panier, qui lit l'attribut
    // au moment meme de l'evenement. Pas d'observateur, donc aucun risque de boucle.
    document.addEventListener('cart:update', function (e) {
      var d = (e.detail && e.detail.data) || {};
      if (d.source === 'product-form-component' && !d.didError) stripAutoOpen();
    }, true);

    document.addEventListener('cart:update', function (e) {
      var d = (e.detail && e.detail.data) || {};
      if (d.source !== 'product-form-component') return;
      if (d.didError) return;
      show(e.detail.sourceId);
    });

    stripAutoOpen();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sv-ct]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-sv-ct-tab]');
      var panels = root.querySelectorAll('[data-sv-ct-panel]');

      root.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-sv-ct-tab]');
        if (!tab) return;

        var key = tab.getAttribute('data-sv-ct-tab');

        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-sv-ct-panel') === key);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-cookies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sv-cookies]');
    if (!root) return;

    var KEY = 'sv_cookie_choice_v' + (root.getAttribute('data-version') || '1');
    var design = window.Shopify && window.Shopify.designMode;

    // Mode test : ajouter ?sv_test=1 à l'adresse réaffiche la bannière (et le
    // pop-up) comme lors d'une première visite. Ce n'est valable que pour ce
    // chargement de page : dès qu'on navigue sans ?sv_test=1, le comportement
    // normal reprend (la bannière ne réapparaît plus une fois la réponse donnée).
    var resetTest = false;
    try { resetTest = /[?&]sv_test=1/.test(window.location.search); } catch (e) {}
    if (resetTest) {
      try { localStorage.removeItem(KEY); } catch (e) {}
      var hideNative = document.createElement('style');
      hideNative.textContent = '#shopify-pc__banner{display:none!important}';
      document.head.appendChild(hideNative);
    }

    function answered() {
      try { return !!localStorage.getItem(KEY); } catch (e) { return false; }
    }

    function nativeBannerPresent() {
      return !!document.getElementById('shopify-pc__banner');
    }

    function announce() {
      try { document.dispatchEvent(new CustomEvent('sv:cookies:answered')); } catch (e) {}
    }

    // Signale l'état aux autres scripts (pop-up) même si la bannière ne s'affiche pas.
    window.SVCookies = {
      answered: answered,
      active: false
    };

    function save(analytics, marketing, label) {
      try { localStorage.setItem(KEY, label); } catch (e) {}

      var apply = function () {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.setTrackingConsent === 'function') {
          try {
            cp.setTrackingConsent(
              { analytics: analytics, marketing: marketing, preferences: analytics, sale_of_data: marketing },
              function () {}
            );
          } catch (e) {}
        }
      };

      if (window.Shopify && window.Shopify.customerPrivacy) {
        apply();
      } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        try {
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            function (error) { if (!error) apply(); }
          );
        } catch (e) {}
      }

      close();
      announce();
    }

    function open() {
      root.hidden = false;
      window.SVCookies.active = true;
    }

    function close() {
      root.hidden = true;
      window.SVCookies.active = false;
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sv-ck-accept]')) { save(true, true, 'all'); return; }
      if (e.target.closest('[data-sv-ck-decline]')) { save(false, false, 'none'); return; }
      if (e.target.closest('[data-sv-ck-custom]')) {
        root.querySelector('[data-sv-ck-prefs]').hidden = false;
        root.querySelector('[data-sv-ck-custom]').hidden = true;
        root.querySelector('[data-sv-ck-accept]').hidden = true;
        root.querySelector('[data-sv-ck-decline]').hidden = true;
        root.querySelector('[data-sv-ck-save]').hidden = false;
        return;
      }
      if (e.target.closest('[data-sv-ck-save]')) {
        var a = root.querySelector('[data-sv-ck-analytics]').checked;
        var m = root.querySelector('[data-sv-ck-marketing]').checked;
        save(a, m, 'custom:' + (a ? 'a' : '') + (m ? 'm' : ''));
      }
    });

    if (design) {
      document.addEventListener('shopify:section:select', function (e) {
        if (root.closest('.shopify-section') === e.target) open();
      });
      document.addEventListener('shopify:section:deselect', close);
      return;
    }

    if (answered()) { announce(); return; }

    // La bannière native de Shopify gère le consentement : on s'efface et on
    // relaie sa réponse pour que le pop-up puisse démarrer son compte à rebours.
    function bridgeNative() {
      close();
      document.addEventListener('visitorConsentCollected', function once() {
        document.removeEventListener('visitorConsentCollected', once);
        try { localStorage.setItem(KEY, 'native'); } catch (e) {}
        announce();
      });
    }

    // Petite attente : si la bannière native de Shopify apparaît, on s'efface.
    setTimeout(function () {
      if (nativeBannerPresent()) { bridgeNative(); return; }

      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function') {
        var should = true;
        try { should = cp.shouldShowBanner(); } catch (e) {}
        if (!should) {
          // Le visiteur a déjà répondu via la bannière native : rien à demander.
          try { localStorage.setItem(KEY, 'native'); } catch (e) {}
          announce();
          return;
        }
      }

      open();

      // Filet de sécurité : si la bannière native arrive un peu plus tard,
      // on se retire pour ne jamais afficher deux bannières.
      var checks = 0;
      var late = setInterval(function () {
        checks++;
        if (nativeBannerPresent()) { clearInterval(late); bridgeNative(); return; }
        if (checks > 8 || root.hidden) clearInterval(late);
      }, 500);
    }, 600);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-favorites"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.querySelector('[data-sv-fav-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-sv-fav-empty]');
    var sub = document.querySelector('[data-sv-fav-sub]');
    var swymApi = null;
    var swymItems = null; // [{empi, epi, du}]

    function money(cents) {
      try {
        return (cents / 100).toLocaleString('fr-FR', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
        });
      } catch (e) {
        return (cents / 100).toFixed(2) + ' €';
      }
    }

    function handleFromUrl(u) {
      var m = String(u || '').match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }

    function card(p, ref) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var src = img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=600' : '';
      var li = document.createElement('li');
      li.className = 'sv-fav__card';
      li.innerHTML =
        '<a class="sv-fav__link" href="/products/' + p.handle + '">' +
        '<span class="sv-fav__media">' +
        (src ? '<img src="' + src + '" alt="" loading="lazy">' : '') +
        '</span>' +
        '<p class="sv-fav__name"></p>' +
        '<p class="sv-fav__price">' + money(p.price) +
        (p.available ? '' : '<span class="sv-fav__soldout">Bientôt de retour</span>') +
        '</p>' +
        '</a>' +
        '<button type="button" class="sv-fav__remove" aria-label="Retirer des favoris">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>';
      li.querySelector('.sv-fav__name').textContent = p.title;
      var btn = li.querySelector('.sv-fav__remove');
      btn.setAttribute('data-handle', p.handle);
      if (ref && ref.empi) btn.setAttribute('data-empi', ref.empi);
      return li;
    }

    function show(handles, refs) {
      grid.innerHTML = '';

      if (!handles.length) {
        if (empty) empty.hidden = false;
        if (sub) sub.textContent = '';
        return;
      }

      if (empty) empty.hidden = true;
      if (sub) sub.textContent = handles.length + (handles.length > 1 ? ' articles sauvegardés' : ' article sauvegardé');

      handles.forEach(function (handle, i) {
        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) {
              if (!swymItems && window.SVWishlist) window.SVWishlist.remove(handle);
              return;
            }
            grid.appendChild(card(p, refs ? refs[i] : null));
          })
          .catch(function () {});
      });
    }

    function renderLocal() {
      var store = window.SVWishlist;
      show(store ? store.read() : [], null);
    }

    function renderSwym() {
      swymApi.fetchLists({
        callbackFn: function (lists) {
          var handles = [], refs = [];
          (lists || []).forEach(function (l) {
            (l.listContents || l.items || []).forEach(function (it) {
              var h = handleFromUrl(it.du);
              if (h && handles.indexOf(h) === -1) {
                handles.push(h);
                refs.push({ empi: it.empi, epi: it.epi, lid: l.lid });
              }
            });
          });
          swymItems = refs;
          show(handles, refs);
        },
        errorFn: function () { renderLocal(); }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.sv-fav__remove') : null;
      if (!btn) return;
      e.preventDefault();

      var handle = btn.getAttribute('data-handle');
      var empi = btn.getAttribute('data-empi');

      if (swymApi && swymItems && empi) {
        var ref = null;
        for (var i = 0; i < swymItems.length; i++) {
          if (String(swymItems[i].empi) === String(empi)) { ref = swymItems[i]; break; }
        }
        if (ref) {
          try {
            swymApi.deleteFromList(ref.lid, { empi: ref.empi, epi: ref.epi }, function () { renderSwym(); }, function () {});
            return;
          } catch (err) {}
        }
      }
      if (window.SVWishlist) window.SVWishlist.remove(handle);
      renderLocal();
    });

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      swymApi = swat;
      renderSwym();
    });

    function start() {
      // On laisse 1,5 s à l'application pour se signaler, sinon repli navigateur.
      setTimeout(function () { if (!swymApi) renderLocal(); }, 1500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sv-pop]');
    if (!root) return;

    var KEY = 'sv_popup_seen_v' + (root.getAttribute('data-version') || '1');
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 12;
    var freq = parseInt(root.getAttribute('data-frequency'), 10);
    if (isNaN(freq)) freq = 7;
    var waitConsent = root.getAttribute('data-wait-consent') === 'true';

    var design = window.Shopify && window.Shopify.designMode;

    // Mode test : ?sv_test=1 dans l'adresse réaffiche le pop-up comme lors
    // d'une première visite, pour ce chargement de page uniquement.
    var resetTest = false;
    try { resetTest = /[?&]sv_test=1/.test(window.location.search); } catch (e) {}
    if (resetTest) {
      try { localStorage.removeItem(KEY); sessionStorage.removeItem('sv_popup_t0'); } catch (e) {}
    }

    function seen() {
      if (freq === 0) return false;
      try {
        var t = parseInt(localStorage.getItem(KEY), 10);
        if (!t) return false;
        return (Date.now() - t) < freq * 86400000;
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }

    function open() {
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (!design) markSeen();
    }

    // Le compte à rebours démarre à l'arrivée sur le site (ou à la réponse
    // cookies) et continue d'une page à l'autre : il ne repart pas de zéro
    // à chaque changement de page.
    function scheduleOpen(fresh) {
      var t0 = 0;
      try {
        if (!fresh) t0 = parseInt(sessionStorage.getItem('sv_popup_t0'), 10) || 0;
        if (!t0) { t0 = Date.now(); sessionStorage.setItem('sv_popup_t0', String(t0)); }
      } catch (e) { t0 = Date.now(); }
      var remaining = delay * 1000 - (Date.now() - t0);
      if (remaining < 800) remaining = 800;
      setTimeout(open, remaining);
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sv-pop-close]')) {
        e.preventDefault();
        close();
        return;
      }
      if (e.target.closest('[data-sv-pop-cta]')) {
        markSeen();
        setTimeout(close, 120);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    function afterConsent(next) {
      if (!waitConsent) { next(); return; }

      var done = false;
      // fresh = true quand la réponse cookies vient d'être donnée à l'instant :
      // le compte à rebours repart alors de ce moment précis.
      var fire = function (fresh) { if (!done) { done = true; next(!!fresh); } };
      var tries = 0;

      var timer = setInterval(function () {
        tries++;

        // 1) Bannière cookies Suverno
        if (window.SVCookies) {
          clearInterval(timer);
          if (window.SVCookies.answered()) { fire(false); return; }
          document.addEventListener('sv:cookies:answered', function once() {
            document.removeEventListener('sv:cookies:answered', once);
            fire(true);
          });
          return;
        }

        // 2) Bannière cookies native de Shopify
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.shouldShowBanner === 'function') {
          clearInterval(timer);
          if (!cp.shouldShowBanner()) { fire(false); return; }
          document.addEventListener('visitorConsentCollected', function once() {
            document.removeEventListener('visitorConsentCollected', once);
            fire(true);
          });
          return;
        }

        if (tries > 40) { clearInterval(timer); fire(false); }
      }, 250);
    }

    if (design) {
      document.addEventListener('shopify:section:select', function (e) {
        if (root.closest('.shopify-section') === e.target) open();
      });
      document.addEventListener('shopify:section:deselect', close);
      return;
    }

    if (seen()) return;
    afterConsent(scheduleOpen);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-suggestions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('.sv-sugg__tab') : null;
    if (!tab) return;
    var root = tab.closest('.sv-sugg');
    if (!root) return;

    var idx = tab.getAttribute('data-sv-tab');

    root.querySelectorAll('.sv-sugg__tab').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    root.querySelectorAll('.sv-sugg__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-sv-panel') === idx);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
